module.exports = __webpack_public_path__ + "img/BAU Seniors_12.fbe64cd9.jpg";